var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLegacyHeartPressed = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.76 3.67a7.53 7.53 0 0 0-5.41-2.27c-1.95 0-3.91.76-5.41 2.27l-.94.96-.95-.97A7.61 7.61 0 0 0 7.63 1.4c-1.96 0-3.91.76-5.39 2.27-2.98 3.05-2.98 7.95 0 10.98L14.01 26.6l10.8-10.98.95-.97c2.99-3.03 2.99-7.93 0-10.98"
  })));
};
export default SvgLegacyHeartPressed;